module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_750_1000.0deb77ad.png";